// extracted by mini-css-extract-plugin
export default {"wrapper":"empty-messages_wrapper__2RcdJ","icon":"empty-messages_icon__rC-i1","title":"empty-messages_title__jJ3b0","text":"empty-messages_text__J1IAZ"};